import { useState } from "react";
import { useTheme } from "../data/data";

export default function ThemeSwitcher() {
  const { theme, setTheme, themes } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <button onClick={() => setOpen(!open)} style={{
        display: "flex", alignItems: "center", gap: 7,
        background: theme.badgeBg, color: theme.badgeText,
        border: `1.5px solid ${theme.border}`,
        borderRadius: 24, padding: "0.38rem 0.95rem",
        fontSize: "0.78rem", fontWeight: 600,
        fontFamily: "'DM Sans',sans-serif", cursor: "pointer",
        transition: "all 0.2s",
      }}
        onMouseEnter={e => e.currentTarget.style.borderColor = theme.primary}
        onMouseLeave={e => e.currentTarget.style.borderColor = theme.border}>
        <span>{theme.emoji}</span>
        <span>{theme.label}</span>
        <span style={{ fontSize: "0.55rem", opacity: 0.7 }}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 998 }} />
          <div style={{
            position: "absolute", top: "calc(100% + 10px)", right: 0,
            background: theme.cardBg, border: `1px solid ${theme.border}`,
            borderRadius: 14, padding: "0.75rem",
            boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
            zIndex: 999, minWidth: 200,
            animation: "dropIn 0.2s ease",
          }}>
            <div style={{ fontSize: "0.62rem", letterSpacing: "0.14em", textTransform: "uppercase", color: theme.textMuted, padding: "0 0.5rem 0.6rem", fontWeight: 600 }}>Select Theme</div>
            {Object.values(themes).map(t => (
              <button key={t.id} onClick={() => { setTheme(t); setOpen(false); }} style={{
                display: "flex", alignItems: "center", gap: 10,
                width: "100%", padding: "0.7rem 0.75rem",
                background: theme.id === t.id ? theme.badgeBg : "transparent",
                border: `1.5px solid ${theme.id === t.id ? theme.primary : "transparent"}`,
                borderRadius: 9, cursor: "pointer",
                fontFamily: "'DM Sans',sans-serif", transition: "all 0.18s",
                marginBottom: 3,
              }}
                onMouseEnter={e => { if (theme.id !== t.id) e.currentTarget.style.background = theme.sectionAlt; }}
                onMouseLeave={e => { if (theme.id !== t.id) e.currentTarget.style.background = "transparent"; }}>
                <div style={{ width: 30, height: 30, borderRadius: "50%", background: t.heroBg, flexShrink: 0, border: "2px solid rgba(255,255,255,0.2)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.85rem" }}>{t.emoji}</div>
                <div style={{ textAlign: "left" }}>
                  <div style={{ fontSize: "0.85rem", fontWeight: 600, color: theme.textPrimary }}>{t.label}</div>
                  <div style={{ fontSize: "0.68rem", color: theme.textMuted, marginTop: 1 }}>
                    {t.id === "blue" ? "Professional & trustworthy" :
                     t.id === "gold" ? "Warm & traditional" :
                     t.id === "green" ? "Natural & fresh" : "Modern dark interface"}
                  </div>
                </div>
                {theme.id === t.id && <span style={{ marginLeft: "auto", color: theme.primary, fontWeight: 700, fontSize: "1rem" }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
